'use client';

import { Button, Heading, Icon, Modal, ModalBody, ModalHeader, TextPassage } from '@petsmart-ui/sparky';
import type { ReactElement } from 'react';

import './PaymentUpdatedConfirmationModal.scss';

export interface PaymentUpdatedConfirmationModalProps {
    readonly isActive: boolean;
    readonly onClose: () => void;
}

export function PaymentUpdatedConfirmationModal({
    isActive,
    onClose,
}: Readonly<PaymentUpdatedConfirmationModalProps>): ReactElement {
    const componentClassName = 'payment-updated-confirmation-modal';

    return (
        <Modal
            className={componentClassName}
            dismissible
            isActive={isActive}
            onClose={onClose}
            data-testid={componentClassName}
        >
            <ModalHeader data-testid="modal-header" closeButtonText="close">
                <Heading tagName="h6" className={`${componentClassName}__heading`}>
                    Payment updated
                </Heading>
                <button
                    className="sparky-c-button sparky-c-modal__close-button sparky-c-button--bare sparky-c-button--circle"
                    aria-pressed="true"
                    type="button"
                    onClick={onClose}
                    data-testid="modal-close-btn"
                >
                    <Icon name="x" />
                </button>
            </ModalHeader>

            <ModalBody data-testid="modal-body">
                <TextPassage className="sparky-u-margin-bottom-md" id="modal-description">
                    <p>All Autoship orders will utilize this card as the default payment method.</p>
                </TextPassage>

                <Button
                    className="ok-button"
                    variant="primary"
                    text="Ok"
                    onClick={onClose}
                    data-testid="modal-ok-button"
                />
            </ModalBody>
        </Modal>
    );
}
